<template>
    <Head title="Dashboard" />
    <div id="accordion">
        <div class="card card-success">
            <div class="card-header">
                <h4 class="card-title w-100">
                    <a class="d-block w-100" data-toggle="collapse" href="#collapseOne">
                        REKAP KUNJUNGAN
                    </a>
                </h4>
            </div>
            <div id="collapseOne" class="collapse" data-parent="#accordion">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm">
                            <div class="info-box bg-primary">
                                <span class="info-box-icon"><i class="far fa-calendar-alt"></i></span>
                                <div class="info-box-content">
                                    <span class="info-box-text">Total Tagihan</span>
                                    <span class="info-box-number">
                                        <h3>{{ this.dashboard.total_tagihan }} | {{ this.dashboard.total_kunjungan }} | {{
                                            this.dashboard.persen_total }}</h3>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm">
                            <div class="info-box bg-info">
                                <span class="info-box-icon"><i class="far fa-calendar-check"></i></span>
                                <div class="info-box-content">
                                    <span class="info-box-text">Tagihan Bawah</span>
                                    <span class="info-box-number">
                                        <h5>{{ this.dashboard.tagihan_bawah }} | {{ this.dashboard.kunjungan_bawah }} | {{
                                            this.dashboard.persen_bawah }}</h5>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm">
                            <div class="info-box bg-pink">
                                <span class="info-box-icon"><i class="far fa-calendar-minus"></i></span>
                                <div class="info-box-content">
                                    <span class="info-box-text">Tagihan Atas</span>
                                    <span class="info-box-number">
                                        <h5>{{ this.dashboard.tagihan_atas }} | {{ this.dashboard.kunjungan_atas }} | {{
                                            this.dashboard.persen_atas }}</h5>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm">
                            <div class="info-box bg-danger">
                                <span class="info-box-icon"><i class="far fa-calendar-times"></i></span>
                                <div class="info-box-content">
                                    <span class="info-box-text">Tagihan Macet</span>
                                    <span class="info-box-number">
                                        <h5>{{ this.dashboard.tagihan_macet }} | {{ this.dashboard.kunjungan_macet }} | {{
                                            this.dashboard.persen_macet }}</h5>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm">
                            <div class="info-box bg-teal">
                                <span class="info-box-icon"><i class="far fa-calendar"></i></span>
                                <div class="info-box-content">
                                    <span class="info-box-text">Tagihan CHR</span>
                                    <span class="info-box-number">
                                        <h5>{{ this.dashboard.tagihan_chr }} | {{ this.dashboard.kunjungan_chr }} | {{
                                            this.dashboard.persen_chr }}</h5>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card card-primary">
            <div class="card-header">
                <h4 class="card-title w-100">
                    <a class="d-block w-100" data-toggle="collapse" href="#collapseTwo">
                        JANJI KUNJUNGAN
                    </a>
                </h4>
            </div>
            <div id="collapseTwo" class="collapse show" data-parent="#accordion">
                <div class="card-body table-responsive">
                    <data-table :columns="columns" :ajax="{ url: '/datatables/janji' }"
                        :columnDefs="[{ targets: [1], className: 'dt-body-center' }]" :order="[2, 'asc']"></data-table>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import Layout from '@/Layouts/Master'
import { Head, Link } from '@inertiajs/vue3'
import DataTable from '@/Forms/DataTable'

export default {
    layout: Layout,
    components: {
        Head,
        Link,
        DataTable,
    },
    props: {
        dashboard: Object,
    },
    data() {
        return {
            columns: [
                { title: 'No', data: 'DT_RowIndex', orderable: false, searchable: false },
                { title: 'Kantor', data: 'tagihan.kantor' },
                { title: 'Tgl Janji', data: 'tgl_janji' },
                { title: 'Rekening', data: 'rek' },
                { title: 'Nama', data: 'tagihan.nama' },
                { title: 'Alamat', data: 'tagihan.alamat' },
                { title: 'Tgl Kunjungan', data: 'created_at' },
            ],
        }
    },
}
</script>
